export const MHCMQTTProtocol = "MQTT-MHC-V1";
